import { APIScope, MemberInviteInterface } from '@swivl-mono/types';
import {
  Button,
  ButtonColor,
  LayoutHeader,
  LayoutWithWideSidebar,
  Spinner
} from '@swivl-mono/ui';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import { ShowIf } from '../../../Components/ShowIf/ShowIf';
import { SidebarLink } from '../../../Components/SidebarLink/SidebarLink';
import MembersModel from '../../../Models/Member/Members.Model';
import ModalModel from '../../../Models/Modal/Modal.Model';
import { InvitePermissionsView } from './Details/InvitePermissions.View';
import { MemberPermissionsView } from './Details/MemberPermissions.View';
import { MembersAddMemberModal } from './Modal/Members.AddMember.Modal';

export function MembersSettingsView() {
  const { members, invites } = MembersModel.useState(s => s, shallow);

  const { memberOrInvite, objectId } = useParams();
  useEffect(() => {
    MembersModel.loadMembers();
    MembersModel.loadInvites();
  }, []);

  let selectedMember, invite;
  if (memberOrInvite === "member" && objectId) {
    selectedMember = members?.find((member) => member.id === parseInt(objectId!));
  } else if (memberOrInvite === "invite" && objectId) {
    invite = invites?.find((invite) => invite.id === parseInt(objectId!));
  }

  return (
    <LayoutWithWideSidebar
      sidebar={
        <div className="flex flex-col overflow-y-auto">
          <LayoutHeader>
            <h2 className=" flex flex-row  justify-between  ">
              <span></span>
              <ShowIf scope={APIScope.MEMBERS_SET}>
                <Button
                  color={ButtonColor.WHITE}
                  onClick={() => {
                    ModalModel.showModalWithContent(
                      <h2>Add a Member</h2>,
                      <MembersAddMemberModal />
                    )
                  }}
                >+ Add Member</Button>
              </ShowIf>
            </h2>
          </LayoutHeader>

          {members ? (
            <>
              {members.map((member) => {
                return (
                  <SidebarLink
                    to={`/settings/members/member/${member.id}`}
                    key={member.id}
                    height={38}
                  >
                    {member.account?.firstName} {member.account?.lastName}
                  </SidebarLink>
                );
              })}

            </>
          ) : (
            <div className="flex align-center justify-center">
              <Spinner />
            </div>
          )}

          {invites ? (
            <>
              {invites.map((invite: MemberInviteInterface) => {
                return (
                  <SidebarLink
                    to={`/settings/members/invite/${invite.id}`}
                    key={invite.id}
                    height={38}
                  >
                    {invite.firstName} {invite.lastName} <label>PENDING</label>
                  </SidebarLink>
                );
              })}

            </>
          ) : null}
        </div>
      }
      content={
        <div>
          {selectedMember && <MemberPermissionsView key={selectedMember.id} member={selectedMember} />}
          {invite && <InvitePermissionsView key={invite.id} invite={invite} />}
        </div>
      }
    />
  );
}
